<template>
  <div>
    <ExecutionResultsDialog title="Report generation" ref="executionResultsDialog">
      <template #actions="{ fileResults }">
        <PrimaryBtn v-if="fileResults && fileResults.length > 0" @click="downloadResults(fileResults)" icon="save_alt" class="my-2 ml-0 mr-2">
          {{ $t('Button.DownloadAnyway') }}
        </PrimaryBtn>
      </template>
    </ExecutionResultsDialog>
    <!-- <PrimaryBtn :loading="loading" icon="save_alt" class="my-2 ml-0 mr-2" @click="generateReport()">
      {{ $t('Button.GenerateReport') }}
    </PrimaryBtn> -->

    <PrimaryBtn :loading="loading" icon="save_alt" class="my-2 ml-0 mr-2" @click="generateReportAsync()">
      Asynchronous Generate Report
    </PrimaryBtn>

    <v-alert v-model="alert" type="info" dismissible>
      Report generation request is submitted. Please check the status of the process at the <a @click="goToMessageCenter">message center</a>.
    </v-alert> 
  </div>
</template>

<script>
  import { downloadFileBytes } from '@/helpers/download'

  import { createNamespacedHelpers } from 'vuex'
  const app = createNamespacedHelpers('app')
  const multiStation = createNamespacedHelpers('multistation')

  export const maxTimeout = 240000 // 4 minutes
  export const errorMessages = {
    unexpected: 'Sorry, we couldn\'t generate this report. We\'re not sure what happened. Please try again — let us know if it happens again.',
    timeout: 'Sorry, the report took too long to generate. Please try again with less data or a shorter date range, and contact Hatfield if you require assistance.',
  }

  export default {
    props: {
      reportParams: Object,
      reportName: String,
    },
    data: () => ({
      loading: false,
      alert: false,
    }),
    computed: {
      reportGenerator() {
        return this.$store.getters['multistation/reportGenerator']
      },
    },
    watch: {
      loading(val) {
        this.$emit('loading', val)
      },
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      ...multiStation.mapActions(['generateSilvertipBCMOEReport', 'generateMoeReportAsync']),
      downloadResults(fileResults) {
        // Only expecting one file result
        fileResults.forEach(({
          fileName,
          data,
        }) => { downloadFileBytes(fileName, data) })

        this.setSnackbar({
          text: 'Report downloaded.',
          color: 'success',
          icon: 'done',
        })
      },
      // async generateReport() {
      //   this.loading = true

      //   this.setSnackbar({
      //     text: 'Please wait as the report may take a few minutes to generate.',
      //     color: 'info',
      //     icon: 'hourglass_top',
      //   })

      //   try {
      //     let reportData = await this.generateSilvertipBCMOEReport(this.reportParams)

      //     if (reportData.isError) this.$refs.executionResultsDialog.show(reportData)
      //     else this.downloadResults(reportData.fileResults)
      //   } catch (error) {
      //     console.log('error', error)
      //     this.$refs.executionResultsDialog.show(error)
      //   }

      //   this.loading = false
      // },
      async generateReportAsync() {
        this.loading = true
        var payload = this.reportParams
        payload.reportName = this.reportName
        await this.generateMoeReportAsync(payload)        
        this.alert = true
        this.loading = false
      },
      goToMessageCenter() {
        this.$router.push({
          name: 'MessageCenter',          
        })
      },
    },
  }
</script>